import React from 'react'
import Button from '@material-ui/core/Button'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import Input from '@material-ui/core/Input'
import IconButton from '@material-ui/core/IconButton'
import CopyIcon from 'react-icons/lib/fa/copy'
import moment from 'moment'
import FileInput from './FileInput'
import Widget from 'cms/Widget'

class View extends React.Component {
  state = {
    thumbnails: {},
  }

  logState = () => console.log(this.state)

  insertThumbnail = (moreThumbnails = {}) =>
    this.setState({
      thumbnails: {
        ...this.state.thumbnails,
        ...moreThumbnails,
      },
    })

  updateThumbnailState = (newThumbnails) =>
    this.setState({
      thumbnails: newThumbnails,
    })

  clearThumbnails = () =>
    this.setState({ thumbnails: {} }, () => {
      // // eslint-disable-next-line
      const elem = document.getElementById('fileInputRef')
      elem.value = ''
    })

  copyLink = (key) => () => {
    const { link } = this.state.thumbnails[key]
    // // eslint-disable-next-line
    navigator.clipboard.writeText(link).then(() => {
      console.log(`Copied to clipboard: ${link}`)
    })
  }

  render() {
    const { state } = this
    const {
      handleSubmit,
      uploadState,
      onFileInputChange,
      onUploadImageDragOver,
      beginUpload,
      fileInputRef,
      keyInputRef,
    } = this.props

    return (
      <Widget>
        <form>
          <Input
            id="bucketFolder"
            placeholder="bucket > bucket's folder"
            name="bucketFolder"
            className="s3t-input"
            type="text"
            margin="dense"
            defaultValue="posts"
            disableUnderline
            required
            fullWidth
          />
          <Input
            placeholder="bucket's folder > bucket folder"
            id="keyInputRef"
            inputRef={keyInputRef}
            name="uploadKey"
            className="s3t-input"
            type="text"
            margin="dense"
            defaultValue={moment().format('YYYY-MM-DD')}
            disableUnderline
            required
            fullWidth
          />
          <FileInput
            fileInputRef={fileInputRef}
            onDragOver={onUploadImageDragOver}
            onChange={onFileInputChange(this.insertThumbnail)}
            className="s3t-file-input"
          />
        </form>

        <div>
          <GridList cellHeight={160} cols={3} style={{ width: '100%' }}>
            {Object.keys(state.thumbnails).map((key, i) => {
              const thumbObj = state.thumbnails[key]
              const { link, size, ...props } = thumbObj
              return (
                <GridListTile key={`thumbnail${i}`}>
                  <img {...props} style={{ objectFit: 'cover' }} />
                  <GridListTileBar
                    title={props.title}
                    subtitle={<span>Size: {size}</span>}
                    actionIcon={
                      <IconButton
                        className="s3t-copy-icon"
                        onClick={this.copyLink(key)}
                        disabled={!link}
                      >
                        <CopyIcon />
                      </IconButton>
                    }
                  />
                </GridListTile>
              )
            })}
          </GridList>
        </div>
        <div>
          <Button
            size="small"
            type="button"
            onClick={beginUpload({
              thumbnails: state.thumbnails,
              updateThumbnailState: this.updateThumbnailState,
            })}
            style={{
              borderRadius: 0,
              marginRight: 3,
              transitin: 'background 0.6, color 0.6s',
            }}
          >
            Upload
          </Button>
          <Button
            size="small"
            type="button"
            onClick={this.clearThumbnails}
            style={{
              borderRadius: 0,
              marginRight: 3,
            }}
          >
            Clear
          </Button>
        </div>
      </Widget>
    )
  }
}

export default View



// WEBPACK FOOTER //
// ./src/cms/widgets/S3Thumbnails/View.js